import type { InspirationAlsoReadBlockDTO } from 'autogen/swagger/all';
import MultiArticleBlocks from './components/MultiArticleBlocks';
import SingleArticleBlock from './components/SingleArticleBlocks';

export type InspirationAlsoReadPlaceholderProps = {
    model: InspirationAlsoReadBlockDTO;
};

export default function InspirationAlsoReadPlaceholder(props: InspirationAlsoReadPlaceholderProps) {
    const { model } = props;

    switch (model.type) {
        case 'MultipleArticleBlock':
            return <MultiArticleBlocks model={model} />;
        case 'SingleWithPicture':
            return <SingleArticleBlock withPicture model={model} />;
        case 'SingleWithOutPicture':
            return <SingleArticleBlock model={model} />;
        default:
            return <div>Missing article type</div>;
    }
}
